module.exports = __webpack_public_path__ + "media/assets/landing_page_island_yellow-82bf559b.svg";